import type { MouseEvent, ReactNode, CSSProperties } from 'react'

export type BtnVariant =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'ghost'
  | 'outline-white'

export interface BtnProps {
  variant?: BtnVariant
  block?: boolean
  sm?: boolean
  disabled?: boolean
  leftIcon?: ReactNode
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  onPointerDown?: (e: React.PointerEvent<HTMLButtonElement>) => void
  style?: CSSProperties
  children?: ReactNode
  type?: 'button' | 'submit' | 'reset'
  className?: string
  'aria-label'?: string
}

export function Btn({
  variant = 'primary',
  block,
  sm,
  disabled,
  leftIcon,
  onClick,
  onPointerDown,
  style,
  children,
  type = 'button',
  className,
  'aria-label': ariaLabel,
}: BtnProps) {
  const cn = [
    'btn',
    `btn--${variant}`,
    block ? 'btn--block' : '',
    sm ? 'btn--sm' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      className={cn}
      disabled={disabled}
      onClick={onClick}
      onPointerDown={onPointerDown}
      style={style}
      aria-label={ariaLabel}
    >
      {leftIcon != null && (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {leftIcon}
        </span>
      )}
      {children}
    </button>
  )
}
